/* lcs-headings-article.js — Blog article semantics (one H1 + UI demote)
 *
 * 2026-09-17 (ffdm, Website 3.0). Three changes to the original:
 *
 *  1. If the template marks its own title with [data-w3-page-title], that IS the
 *     page's H1 and nothing else is promoted. The W3 article template does this.
 *     Without the marker the old behaviour is kept, so the production theme's
 *     article template still works exactly as before.
 *  2. The UI demotion no longer matches a bare `header`. It was matching the
 *     <header> element inside the article itself and turning the headline into
 *     an aria-hidden div. Only site chrome is demoted now.
 *  3. DEBUG off by default. Set it to true to see the decisions in the console.
 */
(function () {
  var DEBUG = false;
  function log(){ if(DEBUG && window.console) try{ console.log.apply(console,arguments);}catch(_){} }

  /* ---------- Guards: articles only ---------- */
  function currentTemplate(){
    var b=document.body;
    var m=(b.className.match(/template-([a-z0-9\-.]+)/i)||[])[1]||'';
    var dt=b.getAttribute('data-template')||document.documentElement.getAttribute('data-template')||'';
    return (dt||m||'').toLowerCase();
  }
  function isArticle(){
    var tpl=currentTemplate();
    if (tpl.indexOf('article')===0) return true;
    return /\/blogs\/[^/]+\/[^/]+/.test(location.pathname);
  }
  if(!isArticle()){ log('[LCS-ARTICLE] Skip on template:', currentTemplate(), 'path:', location.pathname); return; }
  log('[LCS-ARTICLE] Running on', currentTemplate(), location.pathname);

  /* ---------- Helpers ---------- */
  function toPresentational(el){
    if(!el || !/^H[1-6]$/i.test(el.tagName)) return;
    if(el.hasAttribute('data-w3-page-title')) return;   // never demote the marked title
    try{
      var d=document.createElement('div');
      for(var i=0;i<el.attributes.length;i++){ var a=el.attributes[i]; d.setAttribute(a.name,a.value); }
      d.className=(d.className?d.className+' ':'')+'ui-heading';
      d.setAttribute('role','presentation'); d.setAttribute('aria-hidden','true');
      while(el.firstChild) d.appendChild(el.firstChild);
      el.replaceWith(d);
      log('[LCS-ARTICLE] Demoted', el.tagName, '→ DIV');
    }catch(e){}
  }
  function retagKeepStyles(el, tag){
    if(!el || el.tagName.toLowerCase()===tag) return el;
    var n=document.createElement(tag);
    for(var i=0;i<el.attributes.length;i++){ var a=el.attributes[i]; n.setAttribute(a.name,a.value); }
    while(el.firstChild) n.appendChild(el.firstChild);
    el.replaceWith(n);
    return n;
  }
  /* Undo a previous demotion, so a marked title that was turned into a
     presentational div on an earlier pass comes back as a real heading. */
  function unhide(el){
    if(!el) return el;
    el.removeAttribute('role');
    el.removeAttribute('aria-hidden');
    if(el.classList) el.classList.remove('ui-heading');
    return el;
  }

  /* ---------- 1) Demote UI headings (site chrome, drawers, modals, search) ---------- */
  var UI_SCOPES = [
    '#shopify-section-header','body > header','header[role="banner"]','.site-header',
    '.drawer','.modal','.modal__content',
    '.cart-drawer','#CartDrawer','.cart-notification','#CartNotification',
    '.ajaxcart','.mini-cart',
    '.predictive-search','[data-predictive-search]',
    '.quick-add','.quickshop','.product-quickshop','#dialogQuickShopTitle'
  ];
  var UI_SELECTOR = UI_SCOPES.map(function(s){
    return s+' h1,'+s+' h2,'+s+' h3,'+s+' h4,'+s+' h5,'+s+' h6';
  }).join(',');

  function fixUI(root){
    (root||document).querySelectorAll(UI_SELECTOR).forEach(toPresentational);
  }

  /* ---------- 2) Empty headings → presentational ---------- */
  function fixEmpty(root){
    (root||document).querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function(h){
      var t=(h.textContent||'').replace(/\s+/g,'').trim();
      if(!t.length) toPresentational(h);
    });
  }

  /* ---------- 3) Article semantics ---------- */
  function fixArticle(){
    var main=document.querySelector('main')||document;

    // The marked title wins. Otherwise fall back to the old hero lookup.
    var marked=document.querySelector('[data-w3-page-title]');
    var title = marked
      ? unhide(marked)
      : (document.querySelector('.s-header__title, .article__title, .article-title') || main.querySelector('h1, h2'));

    if(title){
      title = retagKeepStyles(title,'h1');
      title.id='page-title';
      title.setAttribute('aria-level','1');
      log('[LCS-ARTICLE] Title → H1', marked ? '(marked)' : '(fallback)');
    }

    // One H1 only.
    var canonical=document.getElementById('page-title');
    main.querySelectorAll('h1').forEach(function(h){
      if(canonical && h!==canonical){ retagKeepStyles(h,'h2'); log('[LCS-ARTICLE] extra H1 → H2'); }
    });
  }

  /* ---------- 4) Keep "Table of Contents" as an H2 ---------- */
  function fixTOC(){
    var main=document.querySelector('main')||document;
    var toc=[].slice.call(main.querySelectorAll('h1,h2,h3,h4,h5,h6')).find(function(h){
      var t=(h.textContent||'').trim().toLowerCase();
      return /^table\s+of\s+contents$/.test(t);
    });
    if(toc && toc.tagName.toLowerCase()!=='h2'){
      retagKeepStyles(toc,'h2');
      log('[LCS-ARTICLE] TOC → H2');
    }
  }

  /* ---------- 5) Demote "Quick shop" if it turns up in the content ---------- */
  function demoteQuickShop(root){
    var base=(root||document);
    base.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function(h){
      var t=(h.textContent||'').trim().toLowerCase();
      if(/^quick\s+shop$/.test(t)) toPresentational(h);
    });
  }

  /* ---------- Run & observe ---------- */
  function run(){ fixUI(); fixEmpty(); fixArticle(); fixTOC(); demoteQuickShop(); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);

  new MutationObserver(function(muts){
    muts.forEach(function(m){
      (m.addedNodes||[]).forEach(function(n){
        if(n && n.nodeType===1){
          fixUI(n); fixEmpty(n); fixArticle(); fixTOC(); demoteQuickShop(n);
        }
      });
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
